export const FIELD_TYPE = {
  TEXT: 'text',
  BOOL: 'bool',
  SELECT: 'select',
};

export const UNNAMED_OPTION_LABEL = 'Unnamed';

export const BUTTON_TYPE = {
  PRIMARY: 'primary',
  OUTLINE: 'outline',
};

export const CONFIRM_BUTTON_LABEL = 'Confirm';
export const SUBMIT_BUTTON_LABEL = 'Submit';
export const CANCEL_BUTTON_LABEL = 'Cancel';

export const FEATURE_PLACEHOLDER = 'Select Feature';
export const OPERATION_PLACEHOLDER = 'Select Action';

export const DEFAULT_SUBMIT_SUCCESS_MESSAGE = 'Action completed successfully';
export const NO_FORM_AVAILABLE_MESSAGE =
  'No form available for this feature and operation yet';
export const MISSING_TARGET_ENDPOINT_MESSAGE =
  'This action is not configured correctly. Please contact support.';
